export default __webpack_public_path__ + "static/media/new-icon.0809dd76.svg";